'use strict';
import React, { Component } from 'react';
// import InputMask from 'react-input-mask';
import { inject, observer } from 'mobx-react';
import Modal, {ModalContainer} from '../modal';
import Keyboard from '../keyboard/keyboard';
// import $ from 'jquery';
// import keyboard from 'virtual-keyboard/dist/js/jquery.keyboard.js';
// import { NumericKeyboard } from 'numeric-keyboard';

const Message = ({text}) => (
	<div className="result-message error">
  	<div className="finance-modal-undefined" dangerouslySetInnerHTML={{ __html: text}}></div>
  </div>
)

@inject('accountStore')
@observer
class LoginForm extends Component {

	constructor(props) {
    super(props);
	}

	phone = React.createRef();
	password = React.createRef();

	handleChange = (e, inputName) => {
    this.props.accountStore.inputAuth(e, inputName);
	}

	status = null;
	inputEl = null;

	handleSubmit = (e) => {
	  e.preventDefault();
	  this.handleFocus(null, 1);
	  if (this.props.accountStore.auth.phone.toString().length < 8 ) {
	  	this.props.accountStore.setAuthError('Неверный номер телефона');
	  	this.phone.current.focus();
	  	return false;
	  } 
	  else if (this.props.accountStore.auth.password.toString().length < 4 ) {
	  	this.props.accountStore.setAuthError('Длина пароля должна содержать не менее 4 символов');
	  	this.password.current.focus();
	  	return false;
	  }
	  this.props.accountStore.sentLogin();
	}

	selectCode = (e) => {
		this.props.accountStore.setPrefix( e.target.value);
	}

	componentDidMount(){
		this.phone.current.focus();
	}

	componentWillUnmount(){
		this.props.accountStore.closeForm();
	}

	handleKeyboard = (val) => {
		if (!this.inputEl) return false;
		this.inputEl.focus();
		if (val == 'b') {
			this.inputEl.value = this.inputEl.value.slice(0, -1);
			this.props.accountStore.inputAuth(this.inputEl.value, this.status);
		} else if (val == 'a') {
			if (this.status == 'phone') {
				this.password.current.focus();
			} else {
				this.props.accountStore.sentLogin();
				this.handleFocus(null, 1);
			}
		} else {
			if (this.inputEl.maxLength > this.inputEl.value.length) {
				this.inputEl.value = this.inputEl.value + String(val);
				this.props.accountStore.inputAuth(this.inputEl.value, this.status);
			}
		}
	}

	handleFocus = (type, st) => {
		if (st) {
			this.status = null;
			this.inputEl = null;
		} else {
			this.status = type;
			this.inputEl = this[type].current;
		}
	}
    
  render() {
  	const {auth, statusdAuthForm, phoneMask, lengthPhoneNumber} = this.props.accountStore;
    return (
    	<ModalContainer>
	    	<Modal show={this.props.show} onCloseModal={this.props.onCloseModal} title="ВХОД ПО НОМЕРУ ТЕЛЕФОНА">
		    	<div className="clearfix">
			    	<form className="login-form" onSubmit={this.handleSubmit}>
				       <div className="clearfix">
			          <div className="login-form_gr clearfix">
			            <div className="input-group">
			                <span className="input-group-addon login-form_prefix_cont">
			                  <select 
				                  	value={auth.phone_prefix}
				                  	name="phone_prefix" 
				                  	className="input-group-addon login-form_prefix_select" 
				                  	tabIndex="1" 
				                  	onChange={this.selectCode}
				                  	disabled={statusdAuthForm.disabled}
			                  	>
		                      <option value="+7">+7</option>
		                      <option value="+38">+38</option>
		                      <option value="+375">+375</option>
		                      <option value="+373">+373</option>
		                    </select>
			                </span>
			                <div>
				                <input 
				                	ref={this.phone}
							        		className="form-control login-form_phone" 
							        		onChange={e => this.handleChange(e.target.value,'phone')} 
							        		placeholder="Номер телефона"
							        		autoComplete="off" 
							        		tabIndex="2"
							        		type="text"
							        		maxLength={lengthPhoneNumber}
							        		disabled={statusdAuthForm.disabled}
							        		value={auth.phone}
							        		onFocus={() => this.handleFocus('phone')}
							        		// onBlur={() => this.handleFocus('phone', 1)}
							        	/>
							        </div>
			                <span className="input-group-addon login-form_attemp"  title="Количество попыток">
			                 {statusdAuthForm.attempts}
			                </span>
			            </div>
			          </div>
			          <div className="login-form_gr clearfix">
			            <input 
				            type="password" 
				            name="password" 
				            className="form-control"
				            pattern="[0-9]{0,6}" 
				            maxLength="6" 
				            placeholder="Пароль" 
				            tabIndex="3" 
				            ref={this.password}
				            value={auth.password}
				            onChange={e => this.handleChange(e.target.value,'password') }
				            disabled={statusdAuthForm.disabled}
				            onFocus={() => this.handleFocus('password')}
				            // onBlur={() => this.handleFocus('password', 1)}
				          />
			          </div>
			       	</div>
			       	<Keyboard type="login" onChange={this.handleKeyboard} />
			       	<div className={`login-form-button-wrp ${statusdAuthForm.status ? 'login-form_error' : ''}`}>
				        <button 
				        	className={`flat_button login-form_login ${statusdAuthForm.wait ? 'wait' : ''}`} 
				        	tabIndex="4" 
				        	type="submit"
				        	disabled={statusdAuthForm.wait}
				        >ВОЙТИ</button>
			        	{statusdAuthForm.status ? <Message text={statusdAuthForm.text}/> : ''}
			        </div>
			    	</form>
		    	</div>
	    	</Modal>
	    </ModalContainer>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/loginForm/index.js